import { Analytics } from "@vercel/analytics/react"
import './App.css';

function App() {
    return (
        <div className="App">
            <h1 className="App-header">Hi👋, <span>I'm <strong>Diana Stanciu</strong>, a front end developer based in Bucharest, Romania</span></h1>
            <p className="App-disclaimer">This website is currently in development, stayed tuned for more 👀</p>
            <p><a href="mailto:diana-frontdev@gmail.com">diana-frontdev@gmail.com</a> / <a
                href="https://www.linkedin.com/in/dianastanciu/" target="_blank">LinkedIn</a> / <a
                href="https://github.com/diana-frontdev" target="_blank">Github</a></p>
            <p>©Diana Stanciu 2017-2025</p>
        </div>
    );
}

export default App;
